export const apexChartsDefaults = {
  colors: ['#3C5587', '#A0966E', '#cda028', '#8A9CBD'],
  chart: {
    fontFamily: 'Lato, sans-serif',
    zoom: {
      enabled: false
    }
  },
  legend: {
    position: 'top',
    horizontalAlign: 'left',
    fontSize: '16px',
    markers: {
      radius: 0,
      width: 16,
      height: 16
    }
  },
  tooltip: {
    fillSeriesColor: false,
    marker: {
      show: false
    },
    x: {
      show: false
    }
  }
};

window.Apex = apexChartsDefaults;
